import { render } from "./studentPaper.vue?vue&type=template&id=06cfb8f6"
import script from "./studentPaper.vue?vue&type=script&lang=js"
export * from "./studentPaper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kk/Documents/纲要解读/Web网站/gyjd-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__